var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MyADGScreenings/MyADGScreeningsInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MyADGScreenings/MyADGScreeningsInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <ul class=\"MyADGScreeningsInner\">\n    ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("screening", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "<li>\n            <a class=\"MyADGScreeningsInner-item\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"link"), env.opts.autoescape);
t_5 += "\">\n                <div class=\"MyADGScreeningsInner-itemDate\">\n                    ";
if(runtime.memberLookup((t_9),"date")) {
t_5 += "<div class=\"MyADGScreeningsInner-itemDay\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%d"), env.opts.autoescape);
t_5 += "</div>\n                    <div class=\"MyADGScreeningsInner-itemMonth\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%b"), env.opts.autoescape);
t_5 += "</div>\n                    ";
;
}
else {
t_5 += "\n                    <div class=\"MyADGScreeningsInner-itemTBD\">TBD</div>\n                    ";
;
}
t_5 += "</div>\n                <div class=\"MyADGScreeningsInner-itemTitle\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "</div>\n                <div class=\"MyADGScreeningsInner-itemDetails\">";
if(runtime.memberLookup((t_9),"location")) {
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"location"), env.opts.autoescape);
;
}
t_5 += "</div>\n                <div class=\"MyADGScreeningsInner-itemArrow\">\n                    ";
t_5 += runtime.suppressValue((lineno = 18, colno = 42, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n                </div>\n            </a>\n        </li>\n    ";
;
}
}
frame = frame.pop();
t_5 += "\n    </ul>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MyADGScreeningsInner");
context.setVariable("MyADGScreeningsInner", macro_t_4);
output += "\n\n\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MyADGScreenings/MyADGScreeningsInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGScreenings/MyADGScreeningsInner.jinja
// module id = 58
// module chunks = 0